var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66675 11.7279C4.66675 7.30963 8.24847 3.72791 12.6667 3.72791C17.085 3.72791 20.6667 7.30963 20.6667 11.7279C20.6667 16.1462 17.085 19.7279 12.6667 19.7279C8.24847 19.7279 4.66675 16.1462 4.66675 11.7279ZM12.6667 1.72791C7.1439 1.72791 2.66675 6.20506 2.66675 11.7279C2.66675 17.2508 7.1439 21.7279 12.6667 21.7279C18.1896 21.7279 22.6667 17.2508 22.6667 11.7279C22.6667 6.20506 18.1896 1.72791 12.6667 1.72791ZM8.66675 11.7279C8.66675 13.937 10.4576 15.7279 12.6667 15.7279C14.8759 15.7279 16.6667 13.937 16.6667 11.7279H14.6667C14.6667 12.8325 13.7713 13.7279 12.6667 13.7279C11.5622 13.7279 10.6667 12.8325 10.6667 11.7279H8.66675ZM11.1667 8.72791C11.1667 9.55633 10.4952 10.2279 9.66675 10.2279C8.83832 10.2279 8.16675 9.55633 8.16675 8.72791C8.16675 7.89948 8.83832 7.22791 9.66675 7.22791C10.4952 7.22791 11.1667 7.89948 11.1667 8.72791ZM15.6667 10.2279C16.4952 10.2279 17.1667 9.55633 17.1667 8.72791C17.1667 7.89948 16.4952 7.22791 15.6667 7.22791C14.8383 7.22791 14.1667 7.89948 14.1667 8.72791C14.1667 9.55633 14.8383 10.2279 15.6667 10.2279Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.547dc27cf4a3398ecaf51c6ea24b1cf3.svg";
export { ForwardRef as ReactComponent };